var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1893",
    "data-name": "Group 1893",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.879,
    height: 15.879,
    viewBox: "0 0 15.879 15.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M12.018,5.51c2.12,0,2.371.008,3.208.046a4.394,4.394,0,0,1,1.474.273,2.629,2.629,0,0,1,1.507,1.507,4.394,4.394,0,0,1,.273,1.474c.038.837.046,1.088.046,3.208s-.008,2.371-.046,3.208a4.394,4.394,0,0,1-.273,1.474A2.629,2.629,0,0,1,16.7,18.208a4.394,4.394,0,0,1-1.474.273c-.837.038-1.088.046-3.208.046s-2.371-.008-3.208-.046a4.394,4.394,0,0,1-1.474-.273A2.629,2.629,0,0,1,5.829,16.7a4.394,4.394,0,0,1-.273-1.474c-.038-.837-.046-1.088-.046-3.208s.008-2.371.046-3.208a4.394,4.394,0,0,1,.273-1.474A2.629,2.629,0,0,1,7.336,5.829,4.394,4.394,0,0,1,8.81,5.556c.837-.038,1.088-.046,3.208-.046m0-1.431c-2.156,0-2.427.009-3.273.048A5.828,5.828,0,0,0,6.818,4.5,4.06,4.06,0,0,0,4.5,6.818a5.828,5.828,0,0,0-.369,1.927c-.039.847-.048,1.117-.048,3.273s.009,2.427.048,3.273A5.828,5.828,0,0,0,4.5,17.219a4.06,4.06,0,0,0,2.322,2.322,5.828,5.828,0,0,0,1.927.369c.847.039,1.117.048,3.273.048s2.427-.009,3.273-.048a5.828,5.828,0,0,0,1.927-.369,4.06,4.06,0,0,0,2.322-2.322,5.828,5.828,0,0,0,.369-1.927c.039-.847.048-1.117.048-3.273s-.009-2.427-.048-3.273a5.828,5.828,0,0,0-.369-1.927A4.06,4.06,0,0,0,17.219,4.5a5.828,5.828,0,0,0-1.927-.369c-.847-.039-1.117-.048-3.273-.048Z",
    transform: "translate(-4.079 -4.079)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M130.712,126.635a4.077,4.077,0,1,0,4.077,4.077A4.077,4.077,0,0,0,130.712,126.635Zm0,6.723a2.646,2.646,0,1,1,2.646-2.646A2.646,2.646,0,0,1,130.712,133.358Z",
    transform: "translate(-122.773 -122.773)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 0.953,
    cy: 0.953,
    r: 0.953,
    transform: "translate(11.225 2.749)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0d19042f97ee715d688addb2d615b2ed.svg";
export { ForwardRef as ReactComponent };